import requestEn from './requestEn';

// 关注
export const followAdd = (param) => {
    return requestEn({
        service: "follow",
        api: "/follow/user/add/encry",
        blendEn: true,
        ...param,
    })
}

// 取消关注
export const followDelete = (param) => {
    return requestEn({
        service: "follow",
        api: "/follow/user/unfollow/encry",
        blendEn: true,
        ...param,
    })
}


// 取消关注
export const profileGet = (param) => {
    return requestEn({
        service: "account",
        api: "/profile/get/env1",
        blendEn: true,
        ...param,
    })
}


// WEBPACK FOOTER //
// ./js/service/index.js